/**
 * Format milliseconds as `m:ss` with zero-padded seconds and unpadded minutes
 * (e.g. 125000 → "2:05"). Guards NaN / negative / non-finite input to "0:00"
 * so it is safe to feed a live audio element's `currentTime`/`duration`.
 */
export const formatTime = (ms: number): string => {
  const totalSeconds =
    Number.isFinite(ms) && ms > 0 ? Math.floor(ms / 1000) : 0;
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

/** Parse "M:SS" or a plain seconds integer into milliseconds. Returns null on invalid input. */
export const parseTime = (text: string): number | null => {
  const trimmed = text.trim();
  if (!trimmed) return null;
  const colonMatch = /^(\d+):([0-5]?\d)$/.exec(trimmed);
  if (colonMatch) {
    const mins = Number(colonMatch[1]);
    const secs = Number(colonMatch[2]);
    return (mins * 60 + secs) * 1000;
  }
  const secsOnly = /^\d+$/.exec(trimmed);
  if (secsOnly) {
    return Number(trimmed) * 1000;
  }
  return null;
};
